var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148007",
    "data-name": "Rectangle 148007",
    width: 20,
    height: 20,
    fill: "#0c0c0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_36",
    "data-name": "Mask Group 36",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M140.672,129.144a.741.741,0,0,0-1.052,0l-4.713,4.713-4.713-4.713a.744.744,0,0,0-1.052,1.052l4.713,4.713-4.713,4.713a.746.746,0,0,0,.523,1.272.725.725,0,0,0,.523-.22l4.713-4.713,4.713,4.713a.748.748,0,0,0,.523.22.716.716,0,0,0,.523-.22.741.741,0,0,0,0-1.052l-4.7-4.713,4.713-4.713A.741.741,0,0,0,140.672,129.144Z",
    transform: "translate(-124.908 -124.908)",
    fill: "#0c0c0b"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimes);
export default __webpack_public_path__ + "static/media/times.7155c00b.svg";
export { ForwardRef as ReactComponent };